// Ofensiva 🔥: o contador com a chama no Início e no perfil, o calendário da semana e o que a partida fez na
// ofensiva no fim. Também a barra da Rodada quente no Início. Tudo calculado no servidor (packages/gamificacao);
// aqui só mostra.
import { useEffect } from 'react';
import type { OfensivaNaTela, OfensivaNoFim, QuenteAgora } from '@truco6/gamificacao';
import { medirUmaVez } from '../comum/medicao.ts';

export const emDias = (n: number) => `${n} ${n === 1 ? 'dia' : 'dias'}`;
const LETRA = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
const NOME_DO_DIA = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
const diaDaSemana = (dia: string) => new Date(dia + 'T12:00:00Z').getUTCDay();

// A frase do Início e do perfil. Enquanto o dia não conta: "Jogue uma partida hoje para manter 6 dias".
export function chamadaDaOfensiva(o: Pick<OfensivaNaTela, 'dias' | 'hojeContou'>): string {
  if (o.hojeContou) return 'Hoje já contou. Volte amanhã para manter.';
  return o.dias > 0 ? `Jogue uma partida hoje para manter ${emDias(o.dias)}` : 'Jogue uma partida hoje para começar a ofensiva';
}

const comPonto = (t: string) => (t.endsWith('.') ? t : t + '.');

function Descansos({ n, max }: { n: number; max?: number }) {
  const texto = max === undefined ? String(n) : `${n}/${max}`;
  return <span className="descansos" aria-label={`${n} ${n === 1 ? 'descanso guardado' : 'descansos guardados'}`}><i aria-hidden="true">💤</i>{texto}</span>;
}

export function OfensivaNoInicio({ o }: { o: OfensivaNaTela }) {
  return (
    <div className={'ofensiva-inicio' + (o.hojeContou ? ' ok' : o.dias ? ' risco' : '')} aria-label={`Ofensiva de ${emDias(o.dias)}`}>
      <span className={'chama' + (o.dias ? '' : ' apagada')} aria-hidden="true">🔥</span>
      <b className="dias">{o.dias}</b>
      <p role="status">{chamadaDaOfensiva(o)}</p>
      {o.descansos > 0 && <Descansos n={o.descansos} />}
    </div>
  );
}

export function OfensivaDoPerfil({ o }: { o: OfensivaNaTela }) {
  return (
    <section className="cartao ofensiva-perfil" aria-label="Sua ofensiva">
      <div className="ofensiva-cab">
        <span className={'chama-grande' + (o.dias ? '' : ' apagada')} aria-hidden="true">🔥</span>
        <p><b>{emDias(o.dias)} de ofensiva</b><small>Recorde: {emDias(o.recorde)}</small></p>
        <Descansos n={o.descansos} max={o.maxDescansos} />
      </div>
      <ol className="semana-ofensiva" aria-label="Últimos 7 dias">
        {o.semana.map((d, i) => {
          const w = diaDaSemana(d.dia), oque = d.tipo === 'jogou' ? 'jogou' : d.tipo === 'descanso' ? 'descanso' : 'sem partida';
          return (
            <li key={d.dia} className={(d.tipo ?? '') + (i === 6 ? ' hoje' : '')} aria-label={`${i === 6 ? 'Hoje' : NOME_DO_DIA[w]}: ${oque}`}>
              <span>{LETRA[w]}</span><i aria-hidden="true">{d.tipo === 'jogou' ? '🔥' : d.tipo === 'descanso' ? '💤' : ''}</i>
            </li>
          );
        })}
      </ol>
      <p className="nota">{comPonto(chamadaDaOfensiva(o))} Descanso protege um dia sem jogar e é usado sozinho.</p>
    </section>
  );
}

// Fim de partida: a primeira partida do dia faz o dia contar. GA4 ofensiva_dia uma vez por partida.
export function OfensivaDaPartida({ o, partida }: { o: OfensivaNoFim; partida: string }) {
  useEffect(() => { if (o.contou) medirUmaVez('ofensiva:' + partida, 'ofensiva_dia', { dias: o.dias }); }, [o.contou, partida]);
  if (!o.contou) return null;
  const titulo = o.marco ? `Ofensiva de ${o.marco} dias!` : `${emDias(o.dias)} de ofensiva`;
  const detalhe = o.retorno
    ? `Que bom te ver de volta. Você tem ${o.descansos} ${o.descansos === 1 ? 'descanso' : 'descansos'} para proteger os próximos dias.`
    : o.dias === 1 ? 'A ofensiva começou. Volte amanhã para manter.' : 'Hoje já contou. Volte amanhã para manter.';
  return (
    <div className={'ofensiva-fim' + (o.marco ? ' marco' : '')} role="status">
      <span aria-hidden="true">🔥</span>
      <p><b>{titulo}</b><small>{detalhe}</small></p>
    </div>
  );
}

// Rodada quente no Início: emendar a próxima partida até 10 minutos depois do fim da anterior soma Rodagem.
export function QuenteNoInicio({ q, agora }: { q: QuenteAgora; agora: number }) {
  if (!q.nivel || !q.ate || q.ate <= agora) return null;
  const min = Math.max(1, Math.ceil((q.ate - agora) / 60_000));
  return (
    <div className="quente-inicio" role="status">
      <b>Rodada quente +{q.bonus}%</b>
      <span>Emende em até {min} min</span>
      <span className="trilho-quente" aria-hidden="true"><i style={{ width: `${Math.min(100, q.bonus)}%` }} /></span>
    </div>
  );
}
